import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React from "react";
import List from "../list";
import { Box, Grid, ResponsiveGrid, Table } from '@alifd/next';
import times from 'lodash/times';
import { MockProductCell } from "./mock-components/mock-product-cell";
import { SkeletonSingle } from "./skeleton";
var Row = Grid.Row,
  Col = Grid.Col;
export function Skeleton(props) {
  return /*#__PURE__*/React.createElement(SkeletonSingle, props);
}
export function SkeletonTab(_ref) {
  var style = _ref.style,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(Box, {
    spacing: 12,
    style: style,
    className: className
  }, /*#__PURE__*/React.createElement(ResponsiveGrid, {
    columns: 6,
    gap: 8
  }, times(4, function () {
    return /*#__PURE__*/React.createElement(ResponsiveGrid.Cell, null, /*#__PURE__*/React.createElement(Skeleton, {
      width: "100%",
      height: 30,
      style: {
        borderRadius: 8
      }
    }));
  })));
}
export function SkeletonFilter(_ref2) {
  var style = _ref2.style,
    className = _ref2.className;
  var Tag = /*#__PURE__*/React.createElement(Skeleton, {
    width: 60,
    height: 26,
    style: {
      borderRadius: 8
    }
  });
  return /*#__PURE__*/React.createElement(Box, {
    spacing: 12,
    style: style,
    className: className
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    spacing: 16,
    align: "center"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    width: 80
  }), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    spacing: 8
  }, times(3, function () {
    return Tag;
  }))), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    spacing: 16
  }, /*#__PURE__*/React.createElement(Skeleton, {
    width: 80
  }), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    spacing: 8
  }, times(5, function () {
    return Tag;
  }))), /*#__PURE__*/React.createElement(ResponsiveGrid, {
    columns: 3,
    gap: 8
  }, times(3, function () {
    return /*#__PURE__*/React.createElement(ResponsiveGrid.Cell, null, /*#__PURE__*/React.createElement(Skeleton, {
      width: "100%",
      height: 30,
      style: {
        borderRadius: 8
      }
    }));
  })));
}
export function SkeletonTable(_ref3) {
  var _ref3$columns = _ref3.columns,
    columns = _ref3$columns === void 0 ? 3 : _ref3$columns,
    className = _ref3.className,
    style = _ref3.style;
  return /*#__PURE__*/React.createElement(Table, {
    className: className,
    style: style,
    dataSource: times(5, function () {
      return {};
    }),
    columns: [{
      title: /*#__PURE__*/React.createElement(Skeleton, {
        width: 120
      }),
      cell: function cell() {
        return /*#__PURE__*/React.createElement(MockProductCell, null);
      }
    }].concat(_toConsumableArray(times(columns - 1, function () {
      return {
        title: /*#__PURE__*/React.createElement(Skeleton, {
          width: 100
        }),
        cell: function cell() {
          return /*#__PURE__*/React.createElement(Skeleton, {
            width: 120,
            height: 16
          });
        }
      };
    })))
  });
}
export function SkeletonList(_ref4) {
  var style = _ref4.style,
    className = _ref4.className;
  var Description = List.Description;
  return /*#__PURE__*/React.createElement(List, {
    className: className,
    style: style,
    dataSource: [{}, {}, {}],
    pagination: {
      total: 0
    },
    toolbar: false,
    renderRow: function renderRow() {
      return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        span: 10
      }, /*#__PURE__*/React.createElement(MockProductCell, null)), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Description, null, times(2, function () {
        return /*#__PURE__*/React.createElement(Description.Item, {
          label: /*#__PURE__*/React.createElement(Skeleton, {
            width: 60
          })
        }, /*#__PURE__*/React.createElement(Skeleton, {
          width: 100
        }));
      }))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Description, null, times(2, function () {
        return /*#__PURE__*/React.createElement(Description.Item, {
          label: /*#__PURE__*/React.createElement(Skeleton, {
            width: 60
          })
        }, /*#__PURE__*/React.createElement(Skeleton, {
          width: 100
        }));
      }))));
    }
  });
}
Skeleton.Tab = SkeletonTab;
Skeleton.Table = SkeletonTable;
Skeleton.List = SkeletonList;
Skeleton.Filter = SkeletonFilter;
export default Skeleton;